import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
  response: [],
};

const updateTeamMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_TEAM_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.UPDATE_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        response: action.payload,
      };
    case types.UPDATE_TEAM_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
        response: [],
      };
    default:
      return state;
  }
};
export default updateTeamMembersReducer;
